<template>
  <app-modal
    v-model="isDialogOpened"
    :cancel-text="$t('common.cancel')"
    :ok-text="$t('common.confirm')"
    :ok-loading="isPending"
    :cancel-disabled="isPending"
    size="xs"
    @cancel="closeDialog"
    @ok="confirmClick"
  >
    <template #title>
      <span>
        {{ $t('project.signing-checklist.prepare-signature.PrepareSignatureDeleteAllTagsDialog.dialogTitle') }}
      </span>
    </template>

    <template #body>
      <p>{{ $t("project.signing-checklist.prepare-signature.PrepareSignatureDeleteAllTagsDialog.dialogBody") }}</p>
    </template>
  </app-modal>
</template>

<script>
import { defineComponent } from 'vue'

import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'PrepareSignatureDeleteAllTagsDialog',
  props: {
    isPending: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [dialogMixin],
  methods: {
    confirmClick () {
      this.$emit('delete-all-tags')
      this.closeDialog()
    },
  },
})
</script>
